import { Injectable, WritableSignal, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutService {
    readonly scrollTop: WritableSignal<number> = signal(0);

    readonly scrollTop$: Observable<number> = toObservable(this.scrollTop);

    setScroll(scrollTop: number) {
        this.scrollTop.set(scrollTop);
    }
}
